import * as React from "react";
function SvgEvolution(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.376 2.5a1.624 1.624 0 00-1.589 1.964L15.51 6.245a1.625 1.625 0 00-2.2.533l-2.872-.768a1.624 1.624 0 10-3.203.237l-2.75 2.747a1.624 1.624 0 10.815.461l2.397-2.394a1.624 1.624 0 002.422-.202l2.941.786a1.624 1.624 0 103.07-.74l2.094-1.636.004.005A1.624 1.624 0 1019.376 2.5zM10.38 9.54a.842.842 0 00-.842.841v9.716H7.51V17.42a.842.842 0 00-.841-.842H4.516a.842.842 0 00-.842.842v2.677h-.722a.451.451 0 000 .902H19.962a.451.451 0 100-.902h-.722V13.9a.842.842 0 00-.842-.843h-2.993v7.039h-2.03V10.38a.842.842 0 00-.842-.842h-2.151z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgEvolution);
export default ForwardRef;
